/*global jQuery*/
(function ($) {
    'use strict';

    $.fn.slideAdSpinner = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('slideAdSpinner');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.slideAdSpinner.defaults, typeof option === 'object' && option
                );

                $element.data('slideAdSpinner', (ctrl = new SlideAdSpinner(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.slideAdSpinner.defaults = {
        totalTime: 4,
        completeDelay: 0,
    };

    function SlideAdSpinner(element, options) {
        this.init(element, options);
    }

    SlideAdSpinner.prototype = {
        constructor: SlideAdSpinner,

        // Properties
        intervalId: 0,
        currentTime: 0,

        // Methods
        init: function (element, options) {
            this.options = options;
            this.$element = $(element);

            if (this.$element.hasClass('slideshow__ad-spinner')) {
                this.$element.addClass('slideshow__ad-spinner');
            }

            this.$element.html(
                '<span class="slideshow__ad-spinner__spinner"></span>' +
                '<span class="slideshow__ad-spinner__spinner"></span>' +
                '<span class="slideshow__ad-spinner__text"></span>'
            );

            this.$text = this.$element.find('.slideshow__ad-spinner__text');
            this.$spinners = this.$element.find('.slideshow__ad-spinner__spinner');

            this.render = this.render.bind(this);
        },

        start: function () {
            this.currentTime = this.options.totalTime;
            this.intervalId = setInterval(this.render, 1000);
            this.$spinners.fadeIn('fast');
            this.render();
        },

        isStopped: function () {
          return this.currentTime === 0;
        },

        stop: function () {
            this.currentTime = 0;

            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = 0;
            }
        },

        render: function () {
            if (this.currentTime === 0) {
                this.showContinue();
            } else {
                this.$text.html(this.currentTime);
                this.currentTime--;
            }
        },

        showContinue: function () {
            this.$text.html('');
            this.$spinners.fadeOut('fast');
            this.stop();

            this.intervalId = setInterval(function () {
                this.$text
                    .hide()
                    .html('<div class="slideshow__ad-spinner__continue"><div></div><div></div></div>')
                    .fadeIn('fast');

                this.stop();
            }.bind(this), this.options.completeDelay);
        },
    };
})(jQuery);
